import React, { useState } from 'react';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { Card, Button, Collapse, Row, Col } from 'react-bootstrap';

const projectContent = [
  {
    title: "Accesibilitate",
    content: [
      "Orice ONG sau fundație poate beneficia de sprijin digital gratuit",
      "Sprijinim organizațiile care ajută comunitățile să aibă o prezență online eficientă",
      "Facilităm accesul la resurse digitale pentru toate organizațiile non-profit"
    ]
  },
  {
    title: "Modernizare",
    content: [
      "Prezență online adaptată nevoilor actuale ale comunităților",
      "Utilizarea tehnologiilor moderne pentru a crește impactul social",
      "Digitalizarea proceselor interne ale ONG-urilor pentru eficiență crescută"
    ]
  },
  {
    title: "Solidaritate",
    content: [
      "Construim împreună o Românie mai conectată și mai solidară",
      "Sprijinim colaborarea între organizații pentru un impact mai mare",
      "Promovăm incluziunea digitală în toate comunitățile"
    ]
  },
  {
    title: "Impact social",
    content: [
      "Creșterea vizibilității și transparenței ONG-urilor",
      "Mobilizarea resurselor și voluntarilor prin platforme digitale",
      "Susținerea inițiativelor cu impact pozitiv în societate"
    ]
  }
];

export default function ProjectDetails() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="w-100" style={{ maxWidth: 900, margin: "48px auto 0 auto" }}>
      <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h2 className="h4 fw-bold" style={{ color: "#143685" }}>
            Detalii proiect „Digital pentru bine”
          </h2>
          <Button
            variant="light"
            onClick={() => setIsExpanded(v => !v)}
            className="border-0 rounded-circle d-flex align-items-center justify-content-center"
            style={{
              boxShadow: "0 2px 8px #e7eaf1",
              background: "#fff",
              color: "#143685",
              width: 44,
              height: 44
            }}
            aria-label={isExpanded ? "Ascunde detalii" : "Afișează detalii"}
          >
            {isExpanded ? <LuChevronUp size={24} /> : <LuChevronDown size={24} />}
          </Button>
        </div>

        <Collapse in={isExpanded}>
          <div>
            <Row className="gy-4">
              {projectContent.map((section, idx) => (
                <Col xs={12} key={idx}>
                  <Card className="mb-3 border-0 shadow-sm rounded-3" style={{ background: "#f5f7fa" }}>
                    <Card.Body>
                      <h3 className="h5 fw-semibold mb-3 pb-2 border-bottom-yellow" style={{ color: "#143685", borderColor: "#FFC72C" }}>
                        {section.title}
                      </h3>
                      <ul className="mb-0 ps-0" style={{ listStyle: "none" }}>
                        {section.content.map((item, itemIdx) => (
                          <li key={itemIdx} className="d-flex align-items-start mb-2">
                            <span
                              style={{
                                width: 8,
                                height: 8,
                                background: "#FFC72C",
                                borderRadius: "50%",
                                marginTop: 8,
                                marginRight: 12,
                                flexShrink: 0
                              }}
                            ></span>
                            <span style={{ color: "#000", lineHeight: 1.6 }}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            <Card className="mt-4 border-0 shadow-sm rounded-3" style={{ background: "#f5f7fa" }}>
              <Card.Body>
                <h4 className="fw-semibold mb-3" style={{ color: "#143685" }}>
                  Beneficiile implementării
                </h4>
                <Row>
                  <Col md={6}>
                    <h5 className="fw-medium mb-2" style={{ color: "#143685" }}>Pentru ONG-uri și fundații:</h5>
                    <ul className="mb-3 ps-3" style={{ color: "#000", fontSize: 15 }}>
                      <li>Creșterea vizibilității și a impactului în comunitate</li>
                      <li>Acces la resurse digitale moderne</li>
                      <li>Sprijin gratuit pentru digitalizare</li>
                    </ul>
                  </Col>
                  <Col md={6}>
                    <h5 className="fw-medium mb-2" style={{ color: "#143685" }}>Pentru societate:</h5>
                    <ul className="mb-3 ps-3" style={{ color: "#000", fontSize: 15 }}>
                      <li>Comunități mai conectate și mai informate</li>
                      <li>Promovarea solidarității și colaborării digitale</li>
                      <li>Incluziune digitală pentru toți</li>
                    </ul>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        </Collapse>

        {!isExpanded && (
          <div className="mt-3 text-center">
            <span className="text-secondary" style={{ fontSize: 14 }}>
              Apăsați pentru a vedea detaliile complete
            </span>
          </div>
        )}
      </Card>
    </div>
  );
}
